export default __webpack_public_path__ + "static/media/piadine.4fec6f71.png";